import { gql, useQuery } from "@apollo/client";

const GET_SALES = gql`
  query GetSales(
    $region: ID
    $district: ID
    $tariffClass: ID
    $tariffClasses: [ID]
    $serviceClass: ServiceClass
    $serviceClasses: [ServiceClass]
    $accountType: AccountType
    $ministry: ID
    $mda: ID
    $isSensitive: Boolean
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
    $category: String
  ) {
    rows: getSales(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      accountType: $accountType
      ministry: $ministry
      mda: $mda
      isSensitive: $isSensitive
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
      category: $category
    ) {
      _id
      billType
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      serviceClass
      geoCode
      accountCode
      meterCode
      meterModelType
      regionCode
      regionName
      districtCode
      districtName
      soeName
      mdaName
      ministryName
      isSensitive
      customerName

      billConsumptionValue
      billConsumptionApparentValue
      billConsumptionMaxDemandValue
      billConsumptionExportValue
      outstandingAmount
      lifeLineAmount
      firstThresholdAmount
      secondThresholdAmount
      energyCharge
      serviceCharge
      energyPlusServiceCharge
      powerFactorSurcharge
      vatCharge
      nhilCharge
      getfundCharge
      streetLightCharge
      nationalElectrificationCharge
      billAmount
      billPeriod
      paymentsAmount
      adjustmentConsumptionValue
      adjustmentAmount
      amountDue
      debtAmount
      debtAge {
        month0
        month1
        month2
        month3
        month4
        month5
        month6
        month7
        month8
        month9
        month10
        month11
        month12
        month13
        month14
        month15
        month16
        month17
        month18
        month19
        month20
        month21
        month22
        month23
        month24
        moreThan24Months
      }
      billAvgConsumptionValue
      billConsumptionType
      lastPaymentAmount
      lastPaymentDate

      month
      year
      createdAt
      updatedAt
    }
    count: getSalesCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      accountType: $accountType
      ministry: $ministry
      mda: $mda
      isSensitive: $isSensitive
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
    )
  }
`;

export const useSales = (variables: any) => {
  const { data, ...rest } = useQuery(GET_SALES, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};

export const DEBT_AGE_BAND_HEADERS = [
  ...Array.from({ length: 25 }, (_, i) => ({
    label: `${i} Months`,
    key: `debtAge.month${i}`,
    customersKey: `debtAge.month${i}Customers`,
    format: "0,0.00",
  })),
  {
    label: "More 24 Months",
    key: "debtAge.moreThan24Months",
    customersKey: "debtAge.moreThan24MonthsCustomers",
    format: "0,0.00",
  },
];
